import React, { Component } from 'react'
import { Flex } from 'reflexbox'

import Body from 'components/typography/body2/index'
import cn from 'classnames'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'

class InputWrapper extends Component {
  render() {
    const styleName = cn(styles.inputContainer, this.props.className)
    return (
      <Flex
        align='center'
        auto
        className={styleName}
      >
        <div className = {styles.inputHeader}>
          <Body>{this.props.label}{this.props.mandatory && <span className={styles.mandatory}> *</span>}</Body>
        </div>
        <div className = {styles.input}>
          {this.props.children}
        </div>
      </Flex>
    )
  }
}


export default CSSModules(styles)(InputWrapper)
